import attack from '../../request/request'
import { EMER } from '../../data/requers_variable.js'
export default {
  /**
  * 撤回预案
  */
  plan_withdraw(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/task/withdraw`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 行业类型
   *
   * @returns
   */
  industytype_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/industytype/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 流程(开始)
   */
  process_start(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/process/start`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 备案中
   */
  process_running(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/search/running`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 备案完成
   */
  process_complete(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/search/complete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 备案不通过，被打回
   */
  process_refused(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/search/refused`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 保存主体信息
   */
  save_subject(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/plan/subject/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * POST /plan/step/save
   * 保存预案申请步骤
   */
  save_step(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/plan/step/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 获取申请步骤
   */
  get_step(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/plan/step/get`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 提交申请
   */
  process_submit(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/process/submit`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 重新提交申请
   */
  process_resubmit(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        // url: `${EMER}/task/resubmit`,
        url: `${EMER}/process/resubmit`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 获取备案地
   */
  process_audit(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/audit`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

  /**
   * 检查文件并删除
   */
  check_del_plan_doc(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/sudden/checkAndDelPlanDoc`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 备案指南文件
   */
  guidance_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/file/guidance/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 备案文件下载
   */
  get_file(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/plandoc/download`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 文件上传
   */
  upload_file(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/file/upload`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  /**
   * 文件下载
   */
  delete_plandoc(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/plandoc/delete`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 预案主体信息
  subject_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/plan/subject/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          reject({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  // 企业 - 预案信息保存(单页面
  save_info(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}/heavypoll/ent/info/save`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
  heavypoll_detail(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/heavypoll/ent/info/detail`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    // 删除草稿
   abandon_plan(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'post',
        url: `${EMER}plan/abandon`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

      // 查询已经上传的文件
   plandoc_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}plandoc/list`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },

      // 查询企业二维码
   get_qecode(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/subject/qrcode`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },


  // added by aimee 20190416

  // 获取提交时下一级的机构信息
  process_audit_first(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/process/dealorg/first`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/emer/weather.js